
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Bu
                    <a href="${0}">Folksonomy Engine layihəsi</a>tərəfindən gətirilir.
                    iştirak etməkdən və ya rəy bildirməkdən çəkinməyin`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Bu alət maddələr siyahısını düzəltməyə imkan verir. Siz
                inqrediyentlər siyahısını əlavə edə, silə və ya redaktə edə bilərsiniz.
                <br>
                Bu simvol <span class="highlight">␣</span> məkanı təmsil edir.
                <br>
                Bu simvol <span class="highlight">↩︎</span> sətir kəsilməsini təmsil edir. `,
'hb28f1f2ec1744ee9': html`Bu xüsusiyyətlər istifadəçilər tərəfindən istənilən növ istifadə üçün yaradılır və təqdim olunur. Özünüzü əlavə etmək üçün
                    sərbəst hiss edin. Yaratdığınız xassələr və dəyərlər
                    <strong>faktiki olmalıdır</strong>. Siz
                    <a href="${0}">icmasının artıq istifadə etdiyi əmlakların siyahısına</a>
                    daxil ola və ya
                    <a href="${1}">xassələri sənədlərini və onun axtarış sistemini</a>araşdıra bilərsiniz.`,
's000a5b76bd3a01c2': `Xüsusiyyətlər yüklənir...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Tərkiblər üçün bizə kömək edin`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Məhsulu təsdiqləyin`,
's03e9c8114521b998': `Tərkibləri redaktə edəcəm`,
's05ec315d9308091a': `Barkod küncləri simvolu`,
's061eb5af92512c85': `Saxlandı! Başqasına kömək edə bilərsən?`,
's06847c221c4c0bc1': `[istifadə halınızı təsvir etmək] üçün əmlak yaratmaq istərdim...`,
's06f6c6f99db6b552': `Orijinal`,
's081e2ad82db71e1d': `Qruplaşdırılmış Dəyərlər`,
's09205907b5b56cda': `Xeyr`,
's0b4235aae602a950': `xüsusi sənədlər`,
's0bb2d48532acc455': `CSV yükləyin`,
's0d5b7fee0311db68': `Əmlak`,
's0fb218abc2e157ed': `Şəkli etibarsız edin`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Məhsulu ləğv edin`,
's11a18a69b30b65ed': `Tərkiblər siyahısındakı səhvləri düzəltməkdə bizə kömək edin`,
's1205d5f6fccf8e69': `Mülkiyyət Dəyəri`,
's15d64a0a6715285a': `Yeni açar`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Seçim sahəsi`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Qidalanma məlumatlarını düzəltməkdə bizə kömək edin`,
's1e00019dc454872d': `Lütfən, mülkiyyət adı atributundan istifadə edərək əmlak adını təqdim edin.`,
's1e49126af0935a5b': `Bu əmlakdan istifadə edən məhsulların siyahısı`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `İmtina`,
's2db7b654c0a9bde0': `Əmlakı sənədləşdirin`,
's300b3a6ee4e1252d': str`Zəif Uyğunluq ${0}%`,
's33f786bb6b4f0cf4': `Bitki Nəticəsi`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Əvvəlcə cəmiyyətdən soruşun`,
's36d86adc823cbfa6': `Yeni əmlak yaratmazdan əvvəl onu icma ilə müzakirə edin:`,
's3781d25aa51a736c': `Folksonomy Mühərrik Sənədləri`,
's383ae4449428b61e': `Məhsulu sıfırlayın`,
's39bcf88721a1e8ee': `Seçimi sıfırlayın`,
's39e14e14300694c7': `Sənədlər və Təlimatlar`,
's3b430cfa5c1fe7f4': str`${0}üçün sənədlər`,
's3f4e4b52f230a892': `Şəkil kətan`,
's417b90913e05bc17': `Önizləmə`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Mərkəzi şəkil`,
's42dd66b2441566fd': `Mərkəz simvolu`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Qidalandırıcı maddə əlavə edin`,
's453ab0dbb9b5c777': `Ölçüsünü sağa dəyişdirin`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Məhsul sayı`,
's4df2f533c0c1e7d0': `Şəkil nəzarətləri`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Seçimi köçürün`,
's4f751fb9b3ed766c': `Yeni Mülk Yaradılması`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Mülk adını daxil edin...`,
's55d7249883a98ca1': `Open Food Facts wiki-də bu əmlak haqqında`,
's565867d84c04aea2': `Xüsusiyyətləri filtrləyin...`,
's5666afe5cd0166de': `Təsdiq etməzdən əvvəl səhvləri düzəldin və ya mətni dəyişdirin`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Məhsullar yüklənir...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Qidalanma məlumatlarını düzəltməkdə bizə kömək edin.`,
's5dd6f12783fca34f': `Tərkiblər siyahısını redaktə edin`,
's5e8250fb85d64c23': `Bağla`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Düzəliş etmək`,
's66413c24dcf680e2': `Ötür`,
's67ae6594857a4d57': `Töhfəniz üçün təşəkkürlər!`,
's6cee7cad81dfedd1': `Kəsilmiş Şəkil`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Yaxşı Uyğunluq ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Sənədləşdirmə`,
's787dd11bed0dc88a': `Ölçüsünü sola dəyişdirin`,
's7ce4fd9430e80cea': `dəyər`,
's801a05fa8e881f37': `Əmlak yaradılması və təlimatlar haqqında ətraflı məlumat əldə edin:`,
's8038273de2cf8b73': `Zəhmət olmasa kəsmək üçün bölgə seçin.`,
's839cc2908a5387f2': `Barkodları süzün...`,
's86197dcf3e96af64': `Mövcud xassələri nəzərdən keçirin və axtarın`,
's8a63be30a129a59c': `Aşağı ölçüsünü dəyişdirin`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Yuxarı sağda ölçüsünü dəyişdirin`,
's8db84aa4bc949af2': `Yeni Mülkiyyəti Sənədləşdirin`,
's8f839a03997a16d7': `Məhsula Baxın`,
's901ae1e236ac45d3': `Silinməni ləğv edin`,
's907f7a97c6b29425': `Məlumat modelinin dəyişdirilə biləcəyindən xəbərdar olun. Öz riskinizlə istifadə edin.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Tərkibi:`,
's9a7f60fce090ecaf': `Xüsusiyyətləri yükləmək alınmadı. Daha sonra yenidən cəhd edin.`,
's9b87abd68fb9df45': `Tapılmadı? Yeni açar yaradın {value}`,
's9c0f52425fd2f07e': `Uyğun Olmaya bilər`,
's9fc41f789c63b40d': `Məhsullar`,
'sa1fa766e0d5634d7': `Xal mövcud deyil`,
'sa548778b24054030': `Folksonomy Engine layihəsindən bütün töhfə verən xassələri araşdırın. Bu xüsusiyyətlər Open Food Facts verilənlər bazasında məhsullar haqqında əlavə metadata və anlayışlar təmin edir.`,
'sa63907958bd0ec4b': `Yuxarı solun ölçüsünü dəyişdirin`,
'sa95b4224f685a36a': `Modalı bağlayın`,
'sab56a1d439576fd6': `Təklif ikonu`,
'sac47ea2901d04c15': `Aşağı solda ölçüsünü dəyişdirin`,
'sb125227d436c2925': `Mövcud əmlak məlumat bazasında əmlak konseptinizi axtarın:`,
'sb125568d43642e6f': `Məhsul haqqında suallara cavab verin.`,
'sb1c538e038f9b214': str`Çox Yaxşı Uyğunluq ${0}%`,
'sb28639570ff3b852': `bütün əmlakların siyahısı`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Mülkünüzün mövcud olmadığını təsdiq etdikdən və icma onun faydalı olduğuna razılaşdıqdan sonra, əvvəlcə onu vikidə sənədləşdirməlisiniz.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Bu əmlak üçün məhsul tapılmadı.`,
'sb7f72e4c8a2d3357': `Dəyərləri filtrləyin...`,
'sb8178320160f84ea': `Məhsulu göstərin`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Bütün məlumatlar cavablandırıldı! Yardımınız üçün təşəkkür edirik!`,
'sbd9a0b2293b3cd3c': `Porsiya ölçüsü`,
'sbe472dc3c2685985': `Müvafiq dəyər`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Üst ölçüsünü dəyişdirin`,
'sc1c08d0cbcc3bd24': `Uyğun Deyil`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Təklif olunan düzəliş`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Şəkli köçürün`,
'sc895972c88d38ca5': `Folksonomiya mülkiyyəti`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Sıralar`,
'scb3b0671d7b7f640': `Yeni dəyər`,
'scb489a1a173ac3f0': `Bəli`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Slack Discussion-a qoşulun`,
'scdb6cad0b92721bf': `Əmlak tapılmadı.`,
'scf23a05631f93732': `Silinməni təsdiqləyin`,
'scfed2f270ef6a3aa': `Ərazi seçin`,
'sd1022bc1ef9204f7': `Böyülə bilən şəkil`,
'sd1077c055cf9ba6b': `Məhsulun tərkib hissələrinin siyahısını təsdiqləməkdə bizə kömək edin.`,
'sd698d21ddecba56b': `hey! Aşağıdakı hissələrə cavab verməklə məhsul məlumatını yaxşılaşdırmaqda bizə kömək edə bilərsiniz:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Mülkiyyətin artıq mövcud olub olmadığını yoxlayın`,
'sdbf806fefc584115': `a tapmaq lazımdır`,
'sdc673e73b5c13aea': `Sil`,
'sdc792b75f1edcaba': `Tərkiblərin yazılışını düzəltməyə kömək edin.`,
'sdca5deead576ceee': `Aşağı sağda ölçüsünü dəyişdirin`,
'sdcc2555c5dde524f': `Bu elementi silmək istədiyinizə əminsiniz? Bu əməliyyat geri qaytarıla bilməz.`,
'se206feec7ec57b28': `100 q üçün`,
'se419a9ab36987490': `Etibarsız etmək`,
'se5127cf0f92e7e48': `İpucu: siz də tapa bilərsiniz`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Mən daha yaxşı məhsul təklif edəcəm`,
'seea3800e27baa686': `Fərdi Məhsullar`,
'sefaba4adc4ec9219': `Folksonomiya xassələri`,
'seffa8ca49175b5f0': `Fərdi xüsusiyyətlər`,
'sf44a6b3b232c28ea': str`Cari dəyəri ${0}ilə əvəz edin`,
'sf4cd86a2f5ef2588': `Məhsulun barkodu`,
'sf57a61152168cc81': `Tərkibinin aşkarlanmasını düzəltməkdə bizə kömək edin`,
'sf88b90b8ba23871c': `Naməlum Uyğunluq`,
'sf9aee319a006c9b4': `Əlavə eləyin`,
'sfacbbe968fa7d773': `Əmlak adı:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Müvafiq dəyər`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  